import axios from "axios"

export const SpecialControlStockApi = {
    // Netsis stok kataloğunda arama + sayfalama (searchbox'ı besler)
    async SearchNetsisStocks(data){
        const response = await axios.post('/api/netsis/item/list', data)
        return response
    },
    async Create(data){
        const response = await axios.post('/api/specialcontrolstock/create', data)
        return response
    },
    async Delete(id){
        const response = await axios.post(`/api/specialcontrolstock/delete/${id}`)
        return response
    },
    async Table(data){
        const response = await axios.post('/api/specialcontrolstock/table', data)
        return response
    }
}
